import React from 'react';
import { Button, Col, Dropdown, Menu, Row, Tag, Typography } from 'antd';
import { ItemType } from 'antd/lib/menu/hooks/useItems';
import { Link } from 'react-router-dom';
import { SettingOutlined } from '@ant-design/icons';
import { Content } from 'antd/lib/layout/layout';
import { ColumnsType } from 'antd/lib/table';

import { FileIcon } from 'components/FileIcon';
import { RegulationsItem } from 'store/slices/regulations/interfaces';
import {
  Statuses,
  statusesColorsHash,
  statusesNamesHash,
} from 'constants/status';
import { CommonTable } from 'components/CommonTable/CommonTable';

import styles from './TableRegulations.module.less';

interface TableRegulationsProps {
  total: number;
  getActions: (item: RegulationsItem) => ItemType[];
  setSort: (sort?: string) => void;
  limit: number;
  items?: RegulationsItem[];
}

export const TableRegulations = ({
  getActions,
  total,
  limit,
  items = [],
  setSort,
}: TableRegulationsProps) => {
  const columns: ColumnsType<TODO_ANY> = [
    {
      key: 'name',
      title: 'Название',
      sorter: true,
      dataIndex: 'name',
      render: (text: string, { id }: RegulationsItem) => (
        <Link to={`/regulations/${id}/edit`}>
          <Row gutter={[12, 0]}>
            <Col>
              <FileIcon />
            </Col>
            <Col style={{ overflow: 'hidden', flex: '1 0' }}>
              <Typography.Text>{text || 'Без названия'}</Typography.Text>
            </Col>
          </Row>
        </Link>
      ),
    },
    {
      key: 'category',
      title: 'Категория',
      dataIndex: 'category',
      width: '20%',
      render: (_: unknown, { categoryData }) => (
        <Typography.Text>{categoryData?.name}</Typography.Text>
      ),
    },
    {
      key: 'status',
      title: 'Статус',
      dataIndex: 'status',
      width: '20%',
      render: (status: Statuses) => (
        <Tag color={statusesColorsHash[status]}>
          {statusesNamesHash[status]}
        </Tag>
      ),
    },
    {
      key: 'actions',
      title: '',
      width: 65,
      dataIndex: 'actions',
      fixed: 'right',
      render: (_: unknown, item: RegulationsItem) => (
        <Dropdown
          placement='bottomRight'
          overlay={
            <Menu className={styles.actionDropdown} items={getActions(item)} />
          }
          arrow
          trigger={['click']}
        >
          <Button type='text' icon={<SettingOutlined />} />
        </Dropdown>
      ),
    },
  ];

  return (
    <Content>
      <CommonTable
        columns={columns}
        scroll={{ x: 800 }}
        total={total}
        limit={limit}
        dataSource={items}
        setSort={setSort}
      />
    </Content>
  );
};
